import React from 'react';
import LedgerDatasetTableShell, { LedgerDatasetTableShellProps } from '../shared/LedgerDatasetTableShell';

type ARLedgerTableProps = Omit<LedgerDatasetTableShellProps, 'view' | 'accountingSource'>;

const ARLedgerTable: React.FC<ARLedgerTableProps> = (props) => (
    <LedgerDatasetTableShell {...props} view="ar" accountingSource="ar_ledger" />
);

export default ARLedgerTable;
